export default __webpack_public_path__ + "static/media/SZ.92e4d2d3.ico";